import React from 'react';
import {
  Button,
  Input,
  Image,
  Modal,
  ModalProps,
  Row,
  Space,
} from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { SiteContent } from 'components/common';
import { playSound } from 'utils';

type Props = ModalProps & {
  onBarcodeMatched: Function;
  openAlertDialog?: Function;
  package: StringKAnyVPair;
};

const ScanBarcodeToPrintDialog = (props: Props) => {
  const { useState } = React;
  const [barcode, setBarcode] = useState<string>('');
  const barcodeInputRef = React.useRef<any>(null);

  const checkBarcode = (bc: string) => {
    const { onBarcodeMatched, onCancel } = props;
    const pbc = props.package.barcode;

    if (pbc === bc) {
      playSound('bell');
      onBarcodeMatched();
      // @ts-ignore
      onCancel && onCancel();
    } else {
      (props.openAlertDialog || Modal.error)({
        title: 'Error',
        content: 'Invalid barcode',
        onClose() {
          if (barcodeInputRef.current) {
            barcodeInputRef.current.select();
          }
        },
      });
    }
  };

  const dialogFooter = () => {
    return (
      <Row justify="end">
        <Space>
          <Button
            onClick={props.onCancel}
            size="large"
          >
            <CloseOutlined />
            Cancel
          </Button>
          <Button
            disabled={!barcode}
            onClick={() => checkBarcode(barcode)}
            size="large"
            type="primary"
          >
            <CheckOutlined />
            OK
          </Button>
        </Space>
      </Row>
    );
  };

  const onChangeBarcode = (evt: any) => {
    const bc = evt.target.value.trim();

    setBarcode(bc);
  };

  const onInputBarcode = (evt: any) => {
    const bc = evt.target.value.trim();

    if ([9, 13].indexOf(evt.keyCode) > -1) {
      checkBarcode(bc);
    }
  };

  return (<>
    <Modal
      {...props}
      footer={dialogFooter()}
    >
      <SiteContent className="common-content">
        <div
          className="img-100p"
          style={{ height: 160 }}
        >
          <Image
            className="h-100p fit-contain"
            preview={false}
            src={props.package.packagePictureLink}
          />
        </div>
        <Input
          allowClear
          autoFocus
          className="fs-20 h-50 mt-16"
          onChange={onChangeBarcode}
          onKeyDown={onInputBarcode}
          placeholder="Input Barcode here"
          ref={barcodeInputRef}
          size="large"
        />
      </SiteContent>
    </Modal>
  </>);
};

export default ScanBarcodeToPrintDialog;
